export default __webpack_public_path__ + "static/media/Privacy_Policy.eefde361.pdf";